import { Link } from "react-router-dom";
import { posts } from "@/mocks/posts";
import { formatCount } from "@/utils/format";

export default function HotRankPanel() {
  const ranked = [...posts].sort((a, b) => b.heat - a.heat).slice(0, 6);

  return (
    <div className="rounded-lg border border-background-200/70 bg-background-50 p-4 md:p-5">
      <div className="flex items-center justify-between mb-2">
        <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
          <i className="ri-fire-fill text-primary-500" aria-hidden="true"></i>
          实时吃瓜热榜
        </h3>
        <Link to="/rank" className="text-xs text-primary-600 whitespace-nowrap hover:underline">
          完整榜单
        </Link>
      </div>
      <ul className="divide-y divide-background-200/70">
        {ranked.map((post, index) => (
          <li key={post.id}>
            <Link to={`/article/${post.id}`} className="group flex items-start gap-3 py-3">
              <span
                className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded text-xs font-bold ${
                  index < 3
                    ? "bg-primary-500 text-background-50"
                    : "bg-background-200 text-foreground-600"
                }`}
              >
                {index + 1}
              </span>
              <div className="min-w-0 flex-1">
                <p className="text-sm font-medium leading-snug text-foreground-900 line-clamp-2 transition-colors group-hover:text-primary-600">
                  {post.title}
                </p>
                <p className="mt-1 text-xs text-foreground-400">
                  热度 {formatCount(post.heat)}
                </p>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}